module.exports = __webpack_public_path__ + "public/img/microsoft-excel-untuk-staf-admin.f0b59a9a.png";